import { useEffect, useState, useCallback } from 'react';
import { fetchGraphql } from '../graphql/fetch';

const POLL_INTERVAL_MS = 60000;

export interface RoundState {
  active:  boolean;
  locked:  boolean;
  name:    string | null;
  endDttm: string | null;
}

export function useRound({ challengeSlug }: { challengeSlug: string }): RoundState {
  const [state, setState] = useState<RoundState>({ active: false, locked: false, name: null, endDttm: null });

  const refetch = useCallback(async () => {
    const res = await fetchGraphql<{ challenge: { viewerSubmissionContext: { lockedRound: boolean; activeRound: { name: string | null; endDttm: string | null } | null } | null } | null }>({
      query: `query R($slug: ID!) {
        challenge(slug: $slug) {
          viewerSubmissionContext {
            lockedRound
            activeRound { name endDttm }
          }
        }
      }`,
      variables: { slug: challengeSlug }
    });
    const ctx = (res && res.data && res.data.challenge && res.data.challenge.viewerSubmissionContext) || null;
    const activeRound = (ctx && ctx.activeRound) || null;
    setState({
      active:  !!activeRound,
      locked:  !!(ctx && ctx.lockedRound),
      name:    activeRound && activeRound.name != null ? activeRound.name : null,
      endDttm: activeRound && activeRound.endDttm != null ? activeRound.endDttm : null
    });
  }, [challengeSlug]);

  useEffect(() => {
    refetch();
    const id = setInterval(refetch, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [refetch]);

  return state;
}
